<template>
  <div>
    <div class="d-flex align-items-center mb-3 temp-con">
      <label
        for="checksSetting"
        class="mb-0 font-weight-normal no-wrap input-label margin-inline-5 temp-checks"
        >{{ $t("journeyBuilder.flow.temperatureCheck") }}</label
      >
      <div class="flex-row mt-3">
        <b-form-group>
          <b-form-radio-group
            v-model="flowChecks.temperature_check_type.value"
            :options="options"
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </div>

    <div class="d-flex align-items-center mb-3">
      <label
        for="checksSetting"
        class="mb-0 font-weight-normal no-wrap input-label margin-inline-4"
        >{{ $t("journeyBuilder.flow.temperatureThreshold") }}</label
      >
      <input
        id="checksSetting"
        v-model="flowChecks.temperature_threshold.value"
        :min="flowChecks.company_temp_unit == 'c' ? 35 : 95"
        :max="flowChecks.company_temp_unit == 'c' ? 45 : 113"
        type="range"
        class="form-control-range"
        step="0.1"
        v-b-tooltip.bottom="
          `${flowChecks.temperature_threshold.value} 
            ${flowChecks.company_temp_unit.toUpperCase()}`
        "
      />
    </div>

    <div class="modal-actions-btns vp-mt-20">
      <VpButton :text="this.$t('common.save')" @click="submit" />
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  props: {
    checksSetting: {
      type: Object,
      default: () => {
        return {
          temperature_threshold: {
            id: null,
            value: null,
            metadata: null,
          },
          temperature_check_type: {
            id: null,
            value: null,
            metadata: null,
          },
          company_temp_unit: null,
        };
      },
    },
  },
  data() {
    return {
      flowChecks: null,
      options: [
        { text: this.$t("journeyBuilder.flow.sampled"), value: "sampled" },
        { text: this.$t("journeyBuilder.flow.rapid"), value: "rapid" },
      ],
    };
  },
  beforeMount() {
    this.flowChecks = cloneDeep(this.checksSetting);
  },
  methods: {
    submit() {
      this.$emit("updateFlowChecks", this.flowChecks);
      this.$bvModal.hide("flowChecks");
    },
  },
};
</script>
<style lang="scss">
div#flowChecks___BV_modal_body_ {
  .custom-control-label span {
    top: 0px !important;
  }
  .margin-inline-4 {
    margin-inline-end: 1.5rem;
  }
  .margin-inline-5 {
    margin-inline-end: 3rem;
  }
}
#flowChecks___BV_modal_header_:lang(ar) button.close {
  margin: -1rem auto -1rem -1rem !important;
}
#flowChecks___BV_modal_content_:lang(ar) .bs-tooltip-bottom {
  transform: translate(-50%, 310%) !important;
}
</style>
